import * as React from 'react'

interface Props {
    percentComplete: number
}

export class ProgressBar extends React.Component<Props, {}> {
    public render() {
        const { percentComplete } = this.props
        const style = {
            width: `${Math.min(percentComplete, 100)}%`,
            backgroundColor: percentComplete >= 100 ? 'var(--green)' : 'var(--primary-color)',
        }
        return (
            <div className="AppCore__ui__ProgressBar">
                <div className="AppCore__ui__ProgressBar__completePart" style={style} />
            </div>
        )
    }
}
